import { gsap } from 'gsap'

import Page from './../../classes/Page'

export default class extends Page {
  constructor () {
    super({
      id: 'default',

      classes: {
        active: 'project--active',
        buttonActive:'is-active',
      },

      element: '#main',
      elements: {
        // default: '.default',
        filterButtons: '[filter-button]',
        activeCategory: '[data-active-category]'
      }
    })
  }

  create () {
    super.create()

    this.isIndex = document.querySelector('[data-project-feed]') ? true : false // project/index view
    this.isShow = document.querySelector('.c-project--single') ? true : false // project/show_archival view
    this.isShowArchive = document.querySelector('.c-project--archive') ? true : false // project/show_archival view

    if (this.isIndex) {
      /* set initial category on filterButtons */
      this.category = this.elements.activeCategory.getAttribute('data-active-category')
      this.elements.filterButtons.forEach(button => {
        console.log('button text', button.dataset.category, this.category)
        if (this.category == button.dataset.category) {
          button.classList.add(this.classes.buttonActive)
        }
      })
    }

    console.log('create PROJECT page');
    
  }

  /**
   * Animations.
   */
  show () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.25
    }

    this.isPopState = false
    this.timelineIn = new gsap.timeline()
  
    if (this.isIndex) { // projects/index view
      import(
        '../../components/ProjectFeed.js' /* webpackChunkName: "components/ProjectFeed" */
      ).then((ProjectFeed) => {
        this.projectFeed = new ProjectFeed.default()

        this.timelineIn.to(this.element, {
          duration: this.duration,
          autoAlpha: 1
        })
      }) 
    } else if (this.isShowArchive) { // projects/show_archival view
      import(
        '../../components/ProjectArchive.js' /* webpackChunkName: "components/ProjectArchive" */
      ).then((projectArchiveView) => {
        this.projectArchive = new projectArchiveView.default()

        this.timelineIn.to(this.element, {
          duration: this.duration,
          autoAlpha: 1
        })
      })
    } else { //projects/show.antlers view
      this.timelineIn.to(this.element, {
        duration: this.duration,
        autoAlpha: 1
      })
    }

    console.log('this.projectFeed', this.projectFeed)

    return super.show(this.timelineIn)
  }

  hide () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.5
    }

    this.timelineOut = new gsap.timeline()

    this.timelineOut.to(this.element, {
      duration: this.duration,
      autoAlpha: 0
    })

    this.timelineOut.call(() => {
      this.destroy()
    })

    return super.hide(this.timelineOut)
  }

  /**
   * Events.
   */
  onTouchDown (event) {

    if (this.isIndex) {
      /* Filter Button States */
      if (event.target.closest('[filter-button]')) {
        console.log('clicked the filter')
        this.elements.filterButtons.forEach(button => {
          button.classList.remove('is-active')
        })
        event.target.classList.add('is-active')
      }
    }

  }

  onPopState () {
    this.isPopState = true
    if (!document.body.classList.contains('is-mobile') && this.isIndex) {
      this.projectFeed.killTweensOf()
      this.projectFeed.resetClonedItems(true)
      this.projectFeed.reinstateEvents()
      this.projectFeed.scrollToAnchor()
      this.projectFeed.updateFilterButtons()
      this.projectFeed.destroyLoadMoreObserver()
    }
  }

  addEventListeners () {

    Livewire.on('projects-init', category => {
      if (this.projectFeed) {
        this.projectFeed.init()
      }
        // alert('A post was InIt with the id of: ' + category);
    })

    Livewire.on('projects-updated', category => {
      if (!document.body.classList.contains('is-mobile')) {
        this.projectFeed.introTimeline()
        this.projectFeed.resetClonedItems(true)
        this.projectFeed.setLoadMoreObserver()
      }
    })

    // if (this.isShowArchive) {
    //   this.projectArchive.addEventListeners()
    // }

  }

  removeEventListeners() {
    // if (document.querySelector('.c-project--archive')) {
    //   this.projectArchive.removeEventListeners()
    // }

    if (this.isShowArchive) {
      this.projectArchive.removeEventListeners()
    }
    
  }
  
  /**
   * Destroy.
   */
  destroy () {
    super.destroy()
    this.removeEventListeners()
  }
}
